export default __webpack_public_path__ + "static/media/Website images-04.aa8efe03.jpg";